import FastMarquee from "react-fast-marquee";

const places = [
  "Katoomba",
  "Leura",
  "Blackheath",
  "Megalong Valley",
  "Jenolan Caves",
  "Wentworth Falls",
  "Echo Point",
  "Glow Worm Tunnel",
  "Lost City",
  "Sydney",
];

export default function EditorialMarquee() {
  return (
    <section
      className="border-y border-white/10 py-10 bg-[#070707] overflow-hidden"
      data-testid="editorial-marquee"
    >
      <FastMarquee speed={25} gradient={false} pauseOnHover>
        {places.map((place) => (
          <span key={place} className="flex items-center">
            <span className="font-serif-lux italic text-3xl md:text-4xl text-[#3a3a3a] px-10 whitespace-nowrap">
              {place}
            </span>
            <span className="w-1.5 h-1.5 rotate-45 bg-[#d4af37]/50 shrink-0" />
          </span>
        ))}
      </FastMarquee>
    </section>
  );
}
